var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { stringify } from 'qs';
import BaseRequest from '@r1-frontend/do-request/core/BaseRequest';
import { captureQueryError } from '@r1-frontend/do-request/error/captureQueryError';
var BaseAxiosRequest = /** @class */ (function (_super) {
    __extends(BaseAxiosRequest, _super);
    function BaseAxiosRequest() {
        return _super.call(this) || this;
    }
    BaseAxiosRequest.prototype.doRequest = function (serviceName, request) {
        return __awaiter(this, void 0, void 0, function () {
            var baseURL, axiosConfig, response, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        baseURL = this.getBaseUrl(serviceName);
                        axiosConfig = this.getConfig(baseURL, request);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, axios.request(axiosConfig)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, {
                                isSuccess: true,
                                payload: response.data,
                            }];
                    case 3:
                        e_1 = _a.sent();
                        // TODO: Обсудить и добавить возможность пробросить кастомный обработчик ошибки
                        return [2 /*return*/, captureQueryError(e_1)];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BaseAxiosRequest.prototype.getConfig = function (baseURL, request) {
        var uri = request.uri, headers = request.headers, method = request.method, body = request.body, queryParams = request.queryParams, withAuth = request.withAuth, responseType = request.responseType, withProvider = request.withProvider, signal = request.signal;
        var defaultHeaders = this.getDefaultHeaders(withAuth, withProvider);
        var axiosConfig = {
            baseURL: baseURL,
            url: uri,
            method: method,
            headers: __assign(__assign({}, defaultHeaders), headers),
            signal: signal || undefined,
        };
        if (queryParams) {
            axiosConfig.params = queryParams;
            axiosConfig.paramsSerializer = function (param) { return stringify(param); };
        }
        if (responseType) {
            axiosConfig.responseType = responseType;
        }
        if (['POST', 'PUT', 'PATCH'].includes(method)) {
            axiosConfig.data = body;
        }
        return axiosConfig;
    };
    return BaseAxiosRequest;
}(BaseRequest));
export default BaseAxiosRequest;
